import React, {Component} from 'react';
import './Footer.css';
// import {Link} from "react-router-dom";
import {HashLink as Link} from 'react-router-hash-link';
import {FormattedMessage} from "react-intl";
import InitialQuotationState from "../../QuotationForm/InitialQuotationState";
import {Modal} from "react-bootstrap";
import UserInquiryForm from "../../UserInquiryForm/UserInquiryForm";
import * as _dispatcher from "react-chat-popup";
import {BASE_URL, PAGE_OPEN_TYPE} from "../../../../configuration";
import ResponsiveFooter from "./ResponsiveFooter";

class Footer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            quotationPcb: {
                orderType: 1,
                fileKey: "",
                pcbParam: {
                    materialDetails: 0,
                    panelFlag: 0,
                    edgeRails: 0,
                    layer: 2,
                    length: 100,
                    width: 100,
                    qty: 5,
                    thickness: 1.6,
                    impedance: 1,
                    pcbColor: 0,
                    surfaceFinish: 0,
                    copperWeight: 1,
                    goldFinger: 0,
                    panelByJLCPCB_X: 0,
                    panelByJLCPCB_Y: 0,
                    differentDesign: 1,
                    flyingProbe: 1,
                    castellatedHoles: 0,
                    silkColor: 1,
                    orderDetailsRemark: ""

                },
                smtStencilParam: {
                    dimensionsID: 112,
                    stencilQty: 1,
                    electropolishing: 0,
                    fiducials: 0,
                    customizeFlag: 0,
                    customizeSizeX: 0,
                    customizeSizeY: 0,
                    customizeSize: 0,
                    stencilSide: 0,
                    orderRemark: "",
                    framework: 0
                }
            },
            quotationStencil: {
                orderType: 3,
                fileKey: "",
                pcbParam: {
                    materialDetails: 0,
                    panelFlag: 0,
                    edgeRails: 0,
                    layer: 2,
                    length: 100,
                    width: 100,
                    qty: 5,
                    thickness: 1.6,
                    impedance: 1,
                    pcbColor: 0,
                    surfaceFinish: 0,
                    copperWeight: 1,
                    goldFinger: 0,
                    panelByJLCPCB_X: 0,
                    panelByJLCPCB_Y: 0,
                    differentDesign: 1,
                    flyingProbe: 1,
                    castellatedHoles: 0,
                    silkColor: 1,
                    orderDetailsRemark: ""

                },
                smtStencilParam: {
                    dimensionsID: 112,
                    stencilQty: 1,
                    electropolishing: 0,
                    fiducials: 0,
                    customizeFlag: 0,
                    customizeSizeX: 0,
                    customizeSizeY: 0,
                    customizeSize: 0,
                    stencilSide: 0,
                    orderRemark: "",
                    framework: 0
                }
            },
            show: false

        };
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.openChat = this.openChat.bind(this);
        this.toPcbQuotationHomePageFooter = this.toPcbQuotationHomePageFooter.bind(this);
        this.toStencilQuotationHomePageFooter = this.toStencilQuotationHomePageFooter.bind(this);

    }

    openChat = () => {
        (0, _dispatcher.toggleChat)();
    };

    handleClose = () => {

        this.setState({show: false});

    };

    handleShow = () => {
        this.setState({show: true});

    };

    toPcbQuotationHomePageFooter = (event) => {

        localStorage.setItem("fromNavi", 2);
        localStorage.setItem("type", 1);
        localStorage.setItem("type1q", JSON.stringify(this.state.quotationPcb));
        window.location.replace(BASE_URL + "quotation/pcb")
    };

    toStencilQuotationHomePageFooter = (event) => {

        localStorage.setItem("fromNavi", 2);
        localStorage.setItem("type", 3);
        localStorage.setItem("type3q", JSON.stringify(this.state.quotationStencil));
        window.location.replace(BASE_URL + "quotation/stencil")

    };

    render() {
        return (
            <footer id="footer-control">
                <div className="footer-middle">
                    <div className="container">
                        <div className="row footer-link-row">
                            <div className="col-md-4 col-sm-4">
                                <div className="footer-pad">
                                    <h4 className="footer-info-title">
                                        {/*<FormattedMessage id="app.footer.service-information"
                                                          defaultMessage="Service Information"
                                                          description=""/>*/}
                                    </h4>
                                    <ul>
                                        <a onClick={() => {
                                            document.getElementById('pcb-home-page-btn-to-quotation').click();
                                            window.scrollTo(0, 0);

                                        }

                                        }>

                                            {/*<li className="list-link">
                                                <FormattedMessage id="app.footer.pcb-quotation"
                                                                  defaultMessage="PCB Quotation"
                                                                  description=""/>
                                            </li>*/}
                                        </a>
                                        <a onClick={() => {
                                            document.getElementById('stencil-home-page-btn-to-quotation').click();
                                            window.scrollTo(0, 0);
                                        }

                                            // this.toStencilQuotationHomePageFooter
                                        }>
                                            {/*<li className="list-link">
                                                <FormattedMessage id="app.footer.smt-quotation"
                                                                  defaultMessage="SMT Quotation"
                                                                  description=""/>
                                            </li>*/}
                                        </a>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-4">
                                <div className="footer-pad">
                                    <h4 className="footer-info-title">
                                        {/*<FormattedMessage id="app.footer.user-guide"
                                                          defaultMessage="User Guide"
                                                          description=""/>*/}
                                    </h4>
                                    <ul>
                                        <Link to="/course/hajimete-user"
                                              target=""
                                        >
                                            {/*<li className="list-link">
                                                <FormattedMessage id="app.footer.user-guide.beginners"
                                                                  defaultMessage="beginners"
                                                                  description=""/>
                                            </li>*/}
                                        </Link>
                                        <Link to="/course/hajimete-guide"
                                              target=""
                                        >
                                            {/*<li className="list-link">
                                                <FormattedMessage id="app.footer.user-guide.flow"
                                                                  defaultMessage="Flow"
                                                                  description=""/>
                                            </li>*/}
                                        </Link>
                                        {/*<Link to="/help/layerHelp"*/}
                                        <a href="https://kitcutlabo.com/course/pcb-standard"
                                           target={PAGE_OPEN_TYPE}
                                        >
                                            {/*<li className="list-link">
                                                <FormattedMessage id="app.footer.user-guide.spec"
                                                                  defaultMessage="Spec"
                                                                  description=""/>
                                            </li>*/}
                                        </a>
                                        <Link to="/course/order"
                                              target=""
                                        >
                                            {/*<li className="list-link">
                                                <FormattedMessage id="app.footer.user-guide.delivery"
                                                                  defaultMessage="Delivery"
                                                                  description=""/>
                                            </li>*/}
                                        </Link>
                                        <Link to="/course/hajimete-guide"
                                              target=""
                                        >
                                            {/*<li className="list-link">
                                                <FormattedMessage id="app.footer.user-guide.payment"
                                                                  defaultMessage="Payment"
                                                                  description=""/>
                                            </li>*/}
                                        </Link>
                                        {/*<Link to="/calendar"
                                              target=""
                                        >*/}
                                            {/*<li className="list-link">
                                                <FormattedMessage id="app.footer.user-guide.calendar"
                                                                  defaultMessage="Calendar"
                                                                  description=""/>
                                            </li>*/}
                                        {/*</Link>*/}
                                        <Link to="/news"
                                              target=""
                                        >
                                            {/*<li className="list-link">
                                                <FormattedMessage id="app.footer.user-guide.information"
                                                                  defaultMessage="Information"
                                                                  description=""/>
                                            </li>*/}
                                        </Link>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-4">
                                <div className="footer-pad">
                                    <h4 className="footer-info-title">
                                        {/*<FormattedMessage id="app.footer.support"
                                                          defaultMessage="Required GERBER DATA"
                                                          description=""/>*/}
                                    </h4>
                                    <ul>
                                        {/*<Link to={{*/}
                                        {/*    pathname: '/frequent',*/}
                                        {/*    state: {*/}
                                        {/*        userId: this.props.userId*/}
                                        {/*    }*/}
                                        {/*}}*/}
                                        {/*      target={PAGE_OPEN_TYPE}*/}
                                        {/*>*/}
                                        {/*    <li className="list-link">*/}
                                        {/*        <FormattedMessage id="app.footer.faq"*/}
                                        {/*                          defaultMessage="Required GERBER DATA"*/}
                                        {/*                          description=""/>*/}
                                        {/*    </li>*/}
                                        {/*</Link>*/}
                                        <a href="https://kitcutlabo.blog/category/pcb-basic-faq
"
                                           target={PAGE_OPEN_TYPE}
                                        >
                                            {/*<li className="list-link">
                                                <FormattedMessage id="app.footer.faq"
                                                                  defaultMessage="Required GERBER DATA"
                                                                  description=""/>
                                            </li>*/}
                                        </a>
                                        <a href="https://kitcutlabo.com/bloglist
"
                                           target={PAGE_OPEN_TYPE}
                                        >
                                            {/*<li className="list-link">
                                                <FormattedMessage id="app.footer.blog"
                                                                  defaultMessage="Required GERBER DATA"
                                                                  description=""/>
                                            </li>*/}
                                        </a>
                                        {/*<li className="list-link footer-point-css" onClick={this.openChat}>
                                            <FormattedMessage id="app.footer.contact"
                                                              defaultMessage="Need Help ?"
                                                              description=""/>
                                        </li>*/}
                                        {/*<li className="list-link footer-point-css" onClick={this.handleShow}>
                                            <FormattedMessage id="app.footer.contact-us"
                                                              defaultMessage="Contact Us"
                                                              description=""/>
                                        </li>*/}
                                        {/*</Link>*/}
                                        <Link to="/course/company-profile"
                                              target=""
                                        >
                                            {/*<li className="list-link">
                                                運営会社
                                            </li>*/}
                                        </Link>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="row footer-link-row">&nbsp;</div>
                        <div className="row footer-link-row">
                            <div className="col-md-4 col-sm-4">
                                <div className="footer-pad">
                                    <h4 className="footer-info-title">
                                        {/*<FormattedMessage id="app.footer.gerber-data"
                                                          defaultMessage="About gerber data creation"
                                                          description=""/>*/}
                                    </h4>
                                    <ul>

                                        <a href="https://kitcutlabo.blog/gerber-file-5"
                                           target={PAGE_OPEN_TYPE}
                                        >
                                            {/*<li className="list-link">

                                                推奨されるガーバー出力ファイル名
                                            </li>*/}
                                        </a>

                                        <a href="https://kitcutlabo.blog/gerber-file-6"
                                           target={PAGE_OPEN_TYPE}
                                        >


                                            {/*<li className="list-link">
                                                KiCADからのガーバー出力方法
                                            </li>*/}
                                        </a>
                                        <a href="https://kitcutlabo.blog/gerber-file-7"
                                           target={PAGE_OPEN_TYPE}
                                        >


                                            {/*<li className="list-link">
                                                EAGLEからのガーバー出力方法
                                            </li>*/}
                                        </a>
                                        <a href="https://kitcutlabo.blog/gerber-file-8"
                                           target={PAGE_OPEN_TYPE}
                                        >


                                            {/*<li className="list-link">
                                                Altiumからのガーバー出力方法
                                            </li>*/}
                                        </a>
                                        <a href="https://kitcutlabo.blog/gerber-file-9"
                                           target={PAGE_OPEN_TYPE}
                                        >


                                            {/*<li className="list-link">
                                                OrCADからのガーバー出力方法
                                            </li>*/}
                                        </a>
                                        <a href="https://kitcutlabo.blog/gerber-file-10"
                                           target={PAGE_OPEN_TYPE}
                                        >


                                            {/*<li className="list-link">
                                                Allegroからのガーバー出力方法
                                            </li>*/}
                                        </a>
                                        {/*</Link>*/}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-4">
                                <div className="footer-pad">
                                    <h4 className="footer-info-title">
                                        {/*<FormattedMessage id="app.footer.delivery"
                                                          defaultMessage="Order and delivery"
                                                          description=""/>*/}
                                    </h4>
                                    <ul>
                                        <Link to="/course/order"
                                              target=""
                                        >
                                            {/*<li className="list-link">
                                                <FormattedMessage id="app.footer.delivery.delivery"
                                                                  defaultMessage="Delivery"
                                                                  description=""/>
                                            </li>*/}
                                        </Link>
                                        <Link to="/course/hajimete-guide"
                                              target=""
                                        >
                                            {/*<li className="list-link">
                                                <FormattedMessage id="app.footer.delivery.payment"
                                                                  defaultMessage="Payment"
                                                                  description=""/>
                                            </li>*/}
                                        </Link>
                                        {/*<Link to="/calendar"
                                              target=""
                                        >*/}
                                            {/*<li className="list-link">
                                                <FormattedMessage id="app.footer.delivery.calendar"
                                                                  defaultMessage="Calendar"
                                                                  description=""/>
                                            </li>*/}
                                        {/*</Link>*/}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-4">
                                <div className="footer-pad">
                                    <h4 className="footer-info-title">
                                        {/*<FormattedMessage id="app.footer.regulation"
                                                          defaultMessage="Regulation"
                                                          description=""/>*/}
                                    </h4>
                                    <ul>
                                        <Link to="/use-policy"
                                              target=""
                                        >
                                            {/*<li className="list-link">
                                                <FormattedMessage id="app.footer.regulation.guide"
                                                                  defaultMessage="Guide"
                                                                  description=""/>
                                            </li>*/}
                                        </Link>
                                        <Link to="/warranty"
                                              target=""
                                        >
                                            {/*<li className="list-link">
                                                <FormattedMessage id="app.footer.regulation.warranty"
                                                                  defaultMessage="Warranty"
                                                                  description=""/>
                                            </li>*/}
                                        </Link>

                                        <Link to="/privacy"
                                              target=""
                                        >
                                            {/*<li className="list-link">
                                                <FormattedMessage id="app.footer.regulation.privacy"
                                                                  defaultMessage="Privacy"
                                                                  description=""/>
                                            </li>*/}
                                        </Link>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="row">
                                <div className="copyright">
                                    ©KitCutLabo. All Rights Reserved.
                                </div>
                            </div>


                            <div>
                                <Modal dialogClassName="contact-modal" show={this.state.show} onHide={this.handleClose}>
                                    <Modal.Header closeButton>
                                        <div className="title-1 color-text">
                                            <FormattedMessage id="app.navigation.contact"
                                                              defaultMessage="Contact"
                                                              description=""/>
                                        </div>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <div className="contact-form-text">
                                            <UserInquiryForm userId={InitialQuotationState.loggedUserId}
                                                             handle={this.handleClose}/>
                                        </div>

                                    </Modal.Body>

                                </Modal>
                            </div>
                            <div className="col-md-12 copy" id="footer-privacy-txt">
                                <p className="text-center">KitcutlaboはCookieを使ってサービスを提供しています。当社のサイトにアクセスすることにより、<a
                                    href="/privacy">プライバシーポリシー</a>に記載されているCookieの使用に同意するものとします。</p>
                            </div>
                        </div>


                    </div>
                </div>
                <div className="responsive-footer">
                    <ResponsiveFooter
                        handleShow={this.handleShow}
                        handleClose={this.handleClose}
                        openChat={this.openChat}
                        toPcbQuotationHomePageFooter={this.toPcbQuotationHomePageFooter}
                        toStencilQuotationHomePageFooter={this.toStencilQuotationHomePageFooter}
                        userId={this.props.userId}
                    />
                </div>
            </footer>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/Footer/Footer.js